import { render, staticRenderFns } from "./ReferralSidebar.vue?vue&type=template&id=06081fd3&"
import script from "./ReferralSidebar.vue?vue&type=script&lang=ts&"
export * from "./ReferralSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralSidebar.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports